// Global Vars
const filtersContainer = $('.courses-list.filters-data-container');
const filtersData = $(filtersContainer).find('.filter-data-list-item');
const coursesListLimit = $('.courses-list').data('limit');
const urlSearchParams = new URLSearchParams(window.location.search);

// Show courses list limited
document.addEventListener('preloaded', function (event) {
    const areFiltersNotPresent = !urlSearchParams.has('filter-topic') && !urlSearchParams.has('filter-region') && !urlSearchParams.has('filter-section');

    if (coursesListLimit > 0 && areFiltersNotPresent) {
        filtersData.each((i, el) => {
            const hasNotReachedCourseListLimit = (i + 1) <= coursesListLimit;

            if (hasNotReachedCourseListLimit) {
                $(el).addClass(['d-block', 'show-limited']);
            } else {
                $(el).addClass(['d-none', 'hide']);
            }
        });
    }
}, false);

// Load more courses if not all are displayed
$('.courses-list-load-more').on('click', function (e) {
    // Disable Link
    e.preventDefault();
    e.stopPropagation();

    // Show hidden courses
    const hiddenCourses = $('.course-list-item.hide');
    hiddenCourses.removeClass(['d-none', 'hide']).addClass(['d-block', 'show-limited']);

    // Hide load more btn
    if ($('.course-list-item.hide').length == 0) {
        $(this).hide();
    }
});
